export default __webpack_public_path__ + "static/media/241.8259aba8.jpg";